<script lang="ts">
    import { TrashIcon } from "@anyways-open/common-svgs";
    import type { OrganizationData, OrganizationUserRoleData, UserData } from "@anyways-open/identity-api-client";
    import { onMount } from "svelte";
    import { appManager } from "../../AppManagerStore";

    export let organization: OrganizationData;
    export let data: OrganizationUserRoleData;
    let user: UserData;
    let canRemove: boolean = false;

    onMount(async () => {
        user = await $appManager.IdentityApi.getCurrentUser();
    });

    // this role can be removed if there are multiple admins or the role is not an admin.
    $: canRemove = data.role.key != "admin" || organization.users.filter(x => x.role.key == "admin").length > 1;

    const onRemove = () => {
        if (!canRemove) return;

        
    };
</script>

<div class="list-group-item">
    <div class="row align-items-center">
        <div class="col-6">
            <p class="mb-0">{data.user.email}</p>

            <p class="d-block small text-truncate text-gray-700">
                {data.user.firstName ?? ""}
                {data.user.lastName ?? ""}
            </p>
        </div>
        <div class="col-auto ms-auto">
            {data.role.name}
        </div>
        <div class="col-auto ms-auto">
            <button
                class="btn icon icon-xs text-dark d-inline p-0"
                title="Delete"
                on:click={onRemove}>
                <TrashIcon />
            </button>
        </div>
    </div>
</div>
